export const FileTranslationsUploadStatus = {
  IN_PROGRESS: 'in-progress' as const,
  COMPLETED: 'completed' as const,
  ERROR: 'error' as const,


  //Validation Processing
  FILE_SIZE_EXCEEDED: 'file-size-exceeded' as const,
  LANGUAGE_ERROR: 'language-error' as const,
  UNSUPPORTED_LANGUAGE: 'unsupported-language' as const,
  PASSWORD_PROTECTED: 'password-protected' as const,
  INSUFFICIENT_TEXT_CONTENT: 'insufficient-text-content' as const,
};
